// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil";

// Import Material UI
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Chip, TextField, Checkbox } from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Recoil
import { initialActions, saveAvailable, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { checkTheDifference, addDifference, removeDifference } from '../../../../helpers/helper';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
export default function LdapQuery({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.LDAP-QUERY.';
  const [value, setValue] = useState([]);
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

  useEffect(() => {
    if (!action.fields.attributes?.value) {
      action.fields.attributes = { value: '', isRequired: true };
      setValue([]);
    }
    else {
      setValue(action.fields.attributes.value);
    }
  }, [action.item_id]);

  const handleChange = (e, newValue) => {
    action.fields.attributes.value = newValue;
    // the difference between the old value and the new value is checked
    const field = initialActionsData[action.id]?.fields.attributes;
    const oldValue = !field ? undefined : field.value;
    const cfTemp = JSON.parse(JSON.stringify(changedFieldsState));
    if (!oldValue) {
      addDifference(cfTemp, action, 'attributes', setChangeFields, setSaveAvailable)
    } else {
      if (checkTheDifference(newValue, oldValue)) {
        addDifference(cfTemp, action, 'attributes', setChangeFields, setSaveAvailable)
      } else {
        removeDifference(cfTemp, action, 'attributes', setChangeFields, setSaveAvailable)
      }
    }
    setValue(newValue);
  };

  return (
    <>
      <div className="conf-field-container">

        <FieldLabel name={t(label + 'QUERY')} is_required={true} />
        <TextInput action={action} inputName="query" variables={variables} setOpenVariable={setOpenVariable} isRequired fieldType="string"
          displayName={t(label + "QUERY")} hideRequired={true} />
        <small className='conf-field-desc'><em>(&(objectCategory=person)(objectClass=user)(sAMAccountName=test))</em></small>
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + 'LDAP')} is_required={true} />
        {/* <Autocomplete multiple freeSolo size="small"
          onChange={handleChange} value={value}
          options={LDAPoptions}
          renderTags={(values, getTagProps) =>
            values.map((option, index) => (
              <Chip variant="outlined" label={option} key={index} {...getTagProps({ index })} />
            ))
          }
          renderInput={params => <TextField {...params} variant="outlined" />}
        /> */}
        <Autocomplete
          freeSolo
          multiple
          onChange={handleChange}
          value={value}
          size="small"
          options={LDAPoptions}
          disableCloseOnSelect
          getOptionLabel={(option) => option}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </React.Fragment>
          )}
          renderInput={params => <TextField {...params} variant="outlined" />}
        />
      </div>
      <div className="conf-field-container">

        <FieldLabel name={t('CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.ASSIGN')} is_required={true} />
        <VariablePicker action={action} inputName="output" variables={variables} setOpenVariable={setOpenVariable} filter="array" isRequired hideRequired={true} />
        <small className='conf-field-desc'><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
      </div>
    </>
  );
}
const LDAPoptions = [
  'userPrincipalName',
  'telephoneNumber',
  'sAMAccountName',
  'displayName',
  'department',
  'givenName',
  'company',
  'manager',
  'mobile',
  'title',
  'name',
  'sn'
];